import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Routess } from "../../Routes/routes";
import { sendError, sendSuccess } from "../../helpers/Helper";
import axios from "axios";
import { FormProvider, useForm } from "react-hook-form";
import { useAuth } from "../../store/AuthContext";
import { API_URL_ENDPOINT } from "../../appsetting";
import { Textbox } from "../../components/Textbox";

export const ResetPassword = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const timestamp = searchParams.get('timestamp');
  const isInvalidLink = !token || !email || !timestamp;
  
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
  } = methods;


  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await axios.post(API_URL_ENDPOINT.ValidateToken, {
          token,
          email,
          timestamp
        });

        if (response.data.status) {
          setIsTokenValid(true);
        } else {
          // sendError(response.data.message || "Invalid or expired token.");
          navigate(Routess.NotFound.path); 
        }
      } catch (err) {
        // sendError("Something went wrong.");
        navigate(Routess.NotFound.path); 
      } finally {
        setIsLoading(false);
      }
    };

    if (token && email && timestamp) {
      validateToken();
    } else {
      navigate(Routess.NotFound.path); 
    }
  }, [token, email, timestamp]);


  const onSubmit = async (param) => {
    try {
      const payload = {
        "email": email,
        "token": token,
        "timestamp": timestamp,
        "newPassword": param.password
      }
      const response = await axios.post(
        API_URL_ENDPOINT.ResetPassword,
        payload,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data?.status) {
        sendSuccess(response.data?.message);
        navigate(Routess.Login.path)
      } else {
        sendError(response.data?.message || "Something went wrong");
      }
    } catch (ex) {
      sendError(
        ex.response?.data?.message || ex.message || "Something went wrong"
      );
    }
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <main>
      <section className="vh-lg-100 mt-4 mt-lg-0 bg-soft d-flex align-items-center">
        <Container>
          <Row className="justify-content-center">
            <p className="text-center">
              <Card.Link
                as={Link}
                to={Routess.Login.path}
                className="text-gray-700"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to
                Log In
              </Card.Link>
            </p>
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="signin-inner my-3 my-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                {successMessage ? (
                  <div className="text-center mt-4">
                    <div className="alert alert-success border-0 shadow-sm">
                      <h5 className="mb-2">✅ Reset Link Sent</h5>
                      <p className="mb-0">{successMessage}</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <h3>Reset your password?</h3>
                    <FormProvider {...methods}>
                      <Form className="mt-4" onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group id="email-group" className="mb-3">
                          <Textbox
                            Type="password"
                            Label="Password"
                            name="password"
                            Placeholder="Enter Your Password"
                            validationRules={{
                              required: "Password is required",
                            }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                        <Form.Group id="email-group" className="mb-3">
                          <Textbox
                            Label="Confirm Password"
                            name="confirmPassword"
                            Placeholder="Confirm Password"
                            validationRules={{
                              required: "Confirm Password is required",
                              validate: (value) =>
                                value === watch("password") ||
                                "Passwords do not match",
                            }}
                            register={register}
                            errors={errors}
                            watch={watch}
                          />
                        </Form.Group>
                        <Button
                          variant="primary"
                          disabled={isSubmitting}
                          type="submit"
                          className="w-100"
                        >
                          {isSubmitting ? "Please Wait..." : "Reset Password"}
                        </Button>
                      </Form>
                    </FormProvider>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
